import React from "react";

import { HvDropdownProps } from "@hitachivantara/uikit-react-core";

import { EventType } from "lib/api";
import BaseDropdown from "../BaseDropdown";

interface EventTypeDropdownProps extends Omit<HvDropdownProps, "values"> {
  selectedEventType?: string;
  events?: EventType[];
}
const EventTypeDropdown = ({
  selectedEventType,
  events,
  ...other
}: EventTypeDropdownProps): JSX.Element => {
  const dropdownValues = events?.map((r) => ({
    id: r.id.toString(),
    label: r.name.toString(),
    selected: selectedEventType === r.id.toString(),
  }));

  return (
    <BaseDropdown
      values={dropdownValues}
      singleSelectionToggle={false}
      {...other}
    />
  );
};

export default EventTypeDropdown;
